import { render, staticRenderFns } from "./EventsUpload.vue?vue&type=template&id=6ab8b690&"
import script from "./EventsUpload.vue?vue&type=script&lang=js&"
export * from "./EventsUpload.vue?vue&type=script&lang=js&"
import style0 from "./EventsUpload.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports